export { MeshGradientComponent } from '@catch/general-ui';
